import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchOrderStatuses, deleteOrderStatus } from "actions/orderStatus";
import { toggleconfirmationPopup, toggleNotification } from "actions/toggle";

import Table from "./Table";
import Pagination from "components/Pagination";

class OrderStatusIndex extends Component {
  componentDidMount() {
    this.props.fetchOrderStatuses();

    this.search = {};
  }

  onSearchFormSubmit = data => {
    this.search = { [data.search_by]: data.search_term };
    this.props.fetchOrderStatuses({ ...this.search });
  };

  onPaginationClick = page => event => {
    const { orderStatusURL: orderStatus_url } = this.props.match.params;
    this.props.fetchOrderStatuses({ orderStatus_url, page, ...this.search });
  };

  handleOrderStatusDelete = id => event => {
    const { toggleconfirmationPopup } = this.props;
    toggleconfirmationPopup(true, {
      onClickDelete: () => {
        this.deleteOrderStatusProcess(id);
      },
      title: "Delete Order Status",
      body: "Are you sure you want to delete this Order Status?"
    });
  };

  deleteOrderStatusProcess(id) {
    const { toggleNotification, toggleconfirmationPopup, deleteOrderStatus, match } = this.props;
    const { orderStatusURL: orderStatus_url } = match.params;
    deleteOrderStatus(id, { orderStatus_url })
      .then(() => {
        this.props.fetchOrderStatuses({ ...this.search });
        toggleNotification(true, { infoClassName: "is-success", message: "Delete Order Status Success" });
        toggleconfirmationPopup(false, {});
      })
      .catch(({ message }) => {
        toggleNotification(true, { infoClassName: "is-danger", message });
        toggleconfirmationPopup(false, {});
      });
  }

  render() {
    const { orderStatuses } = this.props;

    return (
      <div>
        <div className="box">
          <Table orderStatuses={orderStatuses} onClickDelete={this.handleOrderStatusDelete} />
          <Pagination
            onClick={this.onPaginationClick}
            currentPage={orderStatuses.current_page}
            lastPage={orderStatuses.last_page}
            range="4"
            modifyClasses="is-right"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ authOrderStatus, orderStatuses, confirmationPopupActive }) => ({
  authOrderStatus,
  orderStatuses,
  confirmationPopupActive
});

export default connect(
  mapStateToProps,
  { fetchOrderStatuses, deleteOrderStatus, toggleconfirmationPopup, toggleNotification }
)(OrderStatusIndex);



// WEBPACK FOOTER //
// ./src/pages/OrderStatus/Index/index.js